/**
 * @Page REP01
 * @Description [REP01] 수신자료관리 - 기초관리 - 자료생성(수동)
 **/
 import React, { useState, useEffect, useRef, useCallback  } from "react";
 import Ribbon from '@/components/organisms/Ribbon';
 import ContentXearch from '@/components/organisms/ContentXearch';
 import Content from '@/components/organisms/Content';
 import Grid from '@/components/grid/agGrid';
 import CustomAlert from "@/components/molecules/CustomAlert";
 import AlertDialog from '@/components/material-UI/AlertDialog';
 import * as Common from '@/utils/Common'; 
 import CommonUtil from '@/utils/CommonUtil'; 
 import UploadModal from "@/components/organisms/UploadModal";
 
 
 const SERVER_URL = process.env.REACT_APP_BACKEND_SERVER; 
 const CODES = require('@/config/commonCode.json');
 const gbn = [{ "comCode" : "****",  "text": "공통" }];  //조회조건 구분 
 const Utils = new CommonUtil();
 
 function REP01() {
     const token = Common.getToken();
     const userId = Common.getToken("id");
    //  const userName = Common.getToken("name");
     const tVnt1 = Common.getToken("vand");
     const tComp = Common.getToken("comp");
     const bigi = Common.getToken("bigi");
     const grdRep01Main = useRef();   //Grid Main

     const ckVnt1 = Common.getCookie("ck_vnt1"+userId)===null||Common.getCookie("ck_vnt1"+userId)===""||Common.getCookie("ck_vnt1"+userId)==="undefined"?tVnt1:Common.getCookie("ck_vnt1"+userId); 
 
     //Data
     const [idata, setData] = useState({
         kWrcVand : (ckVnt1 === "M000" ? "M000" : ckVnt1),    //업체코드
         kWrcVandReadOnly : (ckVnt1 !== "M000"),   //업체코드 로그인시 입력 불가능
         kVnt1 : tVnt1,      //T1업체
         kWrcVdnm : "",    //업체명+
         kComp : tComp, //회사코드
         kComp2 : "", //회사코드
         kCheck : "",
         kCheck2 : "",
         kPage : "REP01",
         chk1 : "Y",     //자재
         chk2 : "Y",     //생산
         chk3 : "Y",     //클레임
         chk4 : "Y",     //모듈
         chk5 : "Y",     //기타

         vnt1List : [],  //T1업체
         
     }); 
     let comp2 = "";
      
     const [message, setMessage] = React.useState( {
         openAlert : false,      
         severity : "success",   
         msg : ""                
     });
     const { openAlert, severity, msg } = message;
     const [uploadInfo, setUploadInfo] = useState({ vnt1: tVnt1, subDir: "DATA" });
 
     //Dialog
     const [dlgMessage, setDlgMessage] = React.useState( {
         openDlg : false,    
         dlgTrans : "",      // Dialog Transaction(I,U,D)
         dlgMsg : ""         
     });
     const { openDlg, dlgTrans, dlgMsg } = dlgMessage;
 
     //Grid Search, Insert, Update, Delete Api
     let [searchApi, setSearchApi] = useState(false); 
     let [check, setCheckApi] = useState(false); 
     let [insertApi, setInsertApi] = useState(false); 
     let [updateApi, setUpdateApi] = useState(false); 
     let [deleteApi, setDeleteApi] = useState(false); // deleteApi 항목 setting
     let [filedata, setFileData] = useState([]);   //file 
     const [openUpload, setOpenUpload] = React.useState(false); // Modal 항목 setting
     
     const [panded, setPanded] = React.useState(true);
     const [style, setStyle] = useState({ height :"calc(100vh - 65px - 35px - 50px - 21px - 56px - 8px)"});


     const onClearApi = useCallback(async (e) => {
        setSearchApi(false);
        setCheckApi(false);
        setInsertApi(false);
        setUpdateApi(false);
        setDeleteApi(false);
     }, []);
     
     
 
     /**
      * 공통코드 조회
      */
     const onSearchCommon = (para) => {
 
         let commonData = idata;
 
         //그룹코드 조회
         let param = encodeURI(para);
         const query = SERVER_URL + "/comcd/search1?query=" + param; 
     }
 
     const onSearchCommonAsync = async (para, name) => {
        let commonData = idata;

        const fetchData = async (para, name) => {
            let param = encodeURI(para);
            const query = SERVER_URL + "/comcd/search?query=" + param; 
            await fetch(query, { headers: { Authorization: token } })
                .then((resp) => resp.json())
                .then((data) => {
                    if (data.success)
                    {
                        commonData[name] = data.data
                        setData({...commonData});
                    }
                })
        }
        await fetchData(para, name);
    }
 
     /**
      *MOUNT 
      */
     useEffect( () => {
         
         //공통코드 조회
         onSearchCommon(`{"pgmid":"CODE", "vand":"****", "gocd" : "00"}`);
         //공통코드 조회 (T1업체)
         onSearchCommonAsync(`{"pgmid":"VNT1"}`, "vnt1List");

         //조회
         onSearch();
     }, []);
 
 
 
     /**
      * Control 변경 Event
      * @param {*} e 
      */
     const onChange = async (e) => {
         const { name, value } = e.target;
 
         let newSearchs = idata;
         let newUploadInfo = uploadInfo;
         newSearchs[name] = value
 
         setData({ ...newSearchs });
         //setUploadInfo({ ...newUploadInfo });
        
         if(name == "kComp"){
            comp2 = value;

            idata.chk1 = "Y"
            idata.chk2 = "Y"
            idata.chk3 = "Y"
            idata.chk4 = "Y"
            idata.chk5 = "Y"

            setData({ ...newSearchs });
            setUploadInfo({ ...newUploadInfo });
         }
         if(name ==="kWrcVand"){
             
            newUploadInfo["vnt1"] = value;
            setUploadInfo({ ...newUploadInfo });
         }
        
         //조회 Call    
         onSearch(); 
 
     }
 
 
 
     /**
      * Grid Event 
      * @param {*} e 
      */
     const onCellValueChanged = async (e) => {
     }
 
     const onRowClicked = async (e) => {
     }
 
 
 
     /**
      * 검색조건
      */
      const optionsX = {
         0: [
            {
                "formatter": "select", "name": "kComp", "labelName": "회사구분", "type": "text", "defaultValue": idata.kComp,  
                "codeMode": false,
                "selectAll": "",
                //"codes": CODES["comp"],
                "comms": null,
                "align": "left", 
                "items": [{ "comCode": "EHMC", "text": "EHMC 현대자동차(주)ERP" },{ "comCode": "EKMC", "text": "EKMC 기아자동차(주)ERP" },
                          //{ "comCode": "MHMC", "text": "MHMC 현대자동차" }, // .txt 사용 전용 회사(old 버전용)
                          { "comCode": "EHKR", "text": "EHKR 남양시작차" }]
            }, //회사구분
            {
                "formatter": "select", "name": "kWrcVand", "labelName": "T1업체", "type": "text", "defaultValue": idata.kWrcVand, 
                "codeMode": true,
                "selectAll": "", // selectAll :: 전체 option 표출 여부 :: { "comCode" : "" , "text" : "전체" }
                "codes": null,
                "comms": idata.vnt1List, 
                "align": "left", 
            },
            {
                "formatter": idata.kComp=="EHMC"? "check3":idata.kComp=="EKMC"?"check":idata.kComp=="MHMC"?"check3":"blank", "name": "chk1", "labelName": " ",
                "options": idata.kComp=="EHMC" ?[{ "name": "chk1", "labelName": "자재", "defaultValue": idata.chk1 },{ "name": "chk2", "labelName": "생산", "defaultValue": idata.chk2 },
                                                 { "name": "chk5", "labelName": "기타", "defaultValue": idata.chk5 }]
                           :idata.kComp=="EKMC"?[{ "name": "chk1", "labelName": "자재", "defaultValue": idata.chk1 }]
                           :idata.kComp=="MHMC"?[{ "name": "chk3", "labelName": "클레임", "defaultValue": idata.chk3 },{ "name": "chk4", "labelName": "모듈", "defaultValue": idata.chk4 },
                                                 { "name": "chk5", "labelName": "기타", "defaultValue": idata.chk5 }]
                           :""
            },
            {"formatter": "blank", "align": "right" },
            {"formatter": "blank", "align": "right" },
            
         ]
     }
 
     /**
      * 조회 
      * @param {*} e 
      * @returns 
      */
     const onSearch = async (e) => {
        
        let para = `{"kWrcVand":"${idata.kWrcVand}","kWrcVdnm":"${idata.kWrcVdnm}","kComp":"${idata.kComp}","kVnt1":"${idata.kVnt1}"
                    ,"kChk1":"${idata.chk1}","kChk2":"${idata.chk2}","kChk3":"${idata.chk3}","kChk4":"${idata.chk4}","kChk5":"${idata.chk5}"}`;
        let param = encodeURI(para);

        const query = SERVER_URL + "/rep01/search?query=" + param;
        setSearchApi(query); // Search API

        

        
     }
 
 
 
     /**
      * 신규 Row추가
      * @param {*} e 
      */
     const onAddRow = async (e) => {
         
     }
     const onUpload = () => {
        let selectedData = grdRep01Main.current.getSelectedNodes();
        let newSearchs = idata;
        if (selectedData.length === 0) {
            //Alert 창 OPEN
            setMessage({ openAlert : true, 
                         severity : "info",
                         msg : "데이터를 선택해주세요."});
            return false;
        }
        newSearchs["kCheck"] = selectedData[0].data.des2;
        newSearchs["kComp"] = idata.kComp;
        newSearchs["vnt1"] = idata.kWrcVand;

        setData({ ...newSearchs });
        //setData({kCheck:selectedData[0].data.des2,kComp:idata.kComp});
        comp2 = idata.kComp ;
        setOpenUpload(true);
    };
     const handleUploadClickOpen = () => {
        idata.kComp = comp2 ;
        setOpenUpload(true);
    };
 
    const handleUploadClose = () => {
        setOpenUpload(false);
        
    
        onSearchCommonAsync(`{"pgmid":"VNT1"}`, "vnt1List");
        //onSearch();
        
    };
   
     /**
      * 입력
      * @param {*} e 
      */
     const onInsert = async (e) => {
 
     
     }
 
 
 
     /**
      * 수정 
      * @param {*} e 
      * @returns 
      */
     const onUpdate = async (e) => {
 
         
     }
 
 
 
     /**
      * 삭제
      * @param {*} e 
      */
     const onDelete = async (e) => {
         
     }
 
 
 
     // input check
     const inputCheck = (gbn) => { 
 
         let inputFlag = true;
         //select nodes
         let selectedData = grdRep01Main.current.getSelectedNodes();
 
         // 선택 값 체크
         if (selectedData.length === 0) {
             //Alert 창 OPEN
             setMessage({ openAlert : true, 
                          severity : "info",
                          msg : "선택한 데이터가 없습니다."});
             return false;
         }

         return inputFlag;
     }
 
 
 
     //Transaction AlertDialogResult
     const AlertDialogResult = async (e) => {
 
         //AlertDialog 초기화
         setDlgMessage({ openDlg : false,  dlgTrans : "", dlgMsg : ""});
 
         //DialogResult
         if (e.result == "N") return;
 
         //Transaction 구분
         switch (e.Trans) 
         {
             //등록
             case "I" :
                 break;
             //수정
             case "U" :
                 break;
         }
     }
     
     
                           
     /**
      *Grid Column 정의 
      */
     const columnDefs = [
         { headerName: "WRCCOD1", field: "WRCCOD1", sortable: true, filter: true, flex: 1, minWidth: 30, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignL"], singleClickEdit: true, hide: true}, 
         { headerName: "생성자료", field: "WRCDES1", sortable: true, filter: true, flex: 1, minWidth: 30, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignL"], singleClickEdit: true, 
           checkboxSelection : params=> (params.data.gubn === 'N'&& idata.kVnt1!=idata.kWrcVand) ? false : true, hide: false}, //구분이 'N'이고 선택한 업체와 로그인한 업체가 다르면 체크박스 X
         { headerName: "생성파일명", field: "DES2", sortable: true, filter: true, flex: 1, minWidth: 180, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignL"], singleClickEdit: true, hide: false}, 
         { headerName: "총건수", field: "COL1", sortable: true, filter: true, flex: 1, minWidth: 120, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignC"], singleClickEdit: true, hide: false },  //valueFormatter : Utils.numberFormatter
         { headerName: "생성건수", field: "COL2", sortable: true, filter: true, flex: 1, minWidth: 100, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignC"], singleClickEdit: true, hide: false }, 
         { headerName: "중복건수", field: "COL3", sortable: true, filter: true, flex: 1, minWidth: 50, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignC"], singleClickEdit: true, hide: false }, 
     ];
                          
     const onClick = async (e) => {
        setPanded(!panded);

        if(panded===true){
            setStyle({       
                height :"calc(100vh - 65px - 35px - 50px - 21px - 8px)"
              });
        }else{
            setStyle({
                height :"calc(100vh - 65px - 35px - 50px - 21px - 56px - 8px)"
              });
        }
    }

     return(
         <>
             {/* Dialog FRAME */}
             <AlertDialog open={openDlg}  trans={dlgTrans} message={dlgMsg} onClose={AlertDialogResult} />
 
             {/* Alert FRAME */}
             <CustomAlert open={openAlert} severity={severity} duration={3000} message={msg} onClose={()=> {setMessage({openAlert:false, severity:"", msg:"조회 실패"})}} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} />
 
            {/* Upload FRAME */}
            <UploadModal
                open={openUpload}
                onClose={handleUploadClose} 
                onClickOpen={handleUploadClickOpen}
                title={"파일 업로드"}
                fileId={(idata.kCheck).substr(11,5)}
                filePath={idata.kCheck}
                uploadInfo={uploadInfo}
                accp={idata.kCheck.substr(-4)=== ".TXT" ? ".txt":".csv"}
                maxFiles={1}
                validatorName={idata.kCheck.substr(-4)=== ".TXT" ?"txt":"csv"}
                uploadApi={idata.kCheck.substr(-4)=== ".TXT" ? SERVER_URL + "/hkc/upload" :((idata.kCheck).substr(11,5)).slice(-2).startsWith('W')? SERVER_URL + "/erp/claimupload": SERVER_URL + "/erp/upload1"}
                data={idata.vnt1List}
            />
            {/* idata.kComp=="MHMC"?"txt":"csv" */}
             {/* Ribbon Frame : 프로그램 Path 및 버튼 */}
             <Ribbon
                onSearch={onSearch} onSearchName={null} //조회
                //onAddRow={onAddRow} onAddRowName={"신규"}  onAddRowVisible = {tVnt1 === "M000"}  //Row 추가
                onUpload={onUpload}   //자료생성
             >
                {"수신자료관리 > 기초관리 > "}<b style={{ color: "#cd5c5c", fontFamily: "PretendardLight, NanumGothic, sans-serif" }}>자료생성(수동)</b>
             </Ribbon>
 
 
             {/* ContentXearch Frame : 검색조건 */}
             <ContentXearch
                 optionsX={optionsX}
                 onChange={onChange} 
                 onClick={onClick}/>
 
 
             {/* Content FRAME (Data / Grid Frame) START -------------- */}
             <Content style={style}> {/* Content 항목에서의 100%에서 Header:60px,  Ribbon:50px,  검색조건:55px */}
                 <div className={"grid_type01"} > {/* 상단 FRAME */}
                     <div className={"grid_wrap01"}> {/* 상단 wrap FRAME */}
                         <div className="grid_cont_box" style={{ height: "calc(100%)" }}>
                             <Grid
                                 ref={grdRep01Main}
                                 gridId={"REP01"}                    //  (필수) Grid Id 정의
                                 columnDefs={columnDefs}             //  (필수) 컬럼 정의 
                                 pagination={false}                  //  쪽수 매기기 여부
                                 paginationCsv={true}                //  CSV 사용구분 - pagination과 동시에 사용 필요
                                 paginationPageSize={"1000"}         //  쪽수 1Page 당 Row수
                                 rowMultiSelectWithClick={false}      //  멀티 클릭 가능 여부
                                 suppressRowClickSelection={true}    //  클릭으로 선택 하는것을 방지
                                 rowSelection={"single"}           //  여러개 선택 "multiple" 가능, 한개 선택할 때는 "single"
                                 enableRangeSelection={false}        //  
                                 enableCellTextSelection={true}      // cell selection drag mode
                                 isFirst={false}                      // 첫번째 컬럼 체크박스 사용여부 - ( default 체크박스 사용안함 )
                                 displayNo = {false}
                                 checkboxSelection={check} 
                                 searchApi={searchApi}               // 조회
                                 insertApi={insertApi}               // 등록
                                 updateApi={updateApi}               // 수정
                                 deleteApi={deleteApi}               // 삭제
                                 //updateRefresh={onSearch}          // 수정이후 
                                 deleteRefresh={onSearch}            // 삭제이후 
                                 onClearApi={onClearApi}
                                 //onClearApi={()=> {setSearchApi(false); setUpdateApi(false);}}
                                 onCellValueChangedEvent={onCellValueChanged}
                                 onRowClickEvent={onRowClicked}
                                 
                             />
                         </div>
                     </div>
                 </div>
             </Content>
         </>
     )
 }
 export default REP01;
